import React, { ReactElement, useEffect, useState } from 'react'
import { modalFooterRef } from 'ui/NewModalDialog/ModalDialogFooter'
import { createPortal } from 'react-dom'
import { Flex } from 'theme-ui'
import ButtonWithLoadingState from 'components/ButtonWithLoadingState/ButtonWithLoadingState'

export default function DeleteAndCancelButtons({
  isDeleteButtonDisabled,
  isDeleteLoading,
  onCancelClick,
  onDeleteClick,
  deleteTestId,
}: {
  isDeleteButtonDisabled: boolean
  isDeleteLoading: boolean
  onCancelClick?: () => void
  onDeleteClick?: () => void
  deleteTestId?: string
}): ReactElement | null {
  const [shouldAppendButton, setShouldAppendButton] = useState(false)

  useEffect(() => {
    setShouldAppendButton(!!modalFooterRef.current)
  }, [])

  // adding a button to the dialog footer so as not to move all dependencies and states to the top level component
  return shouldAppendButton && modalFooterRef.current
    ? createPortal(
        <Flex sx={{ width: '100%', justifyContent: 'flex-end', gap: '1.2rem' }}>
          <ButtonWithLoadingState
            variant="newTertiary"
            data-testid="cancel-button"
            ariaLabel="cancel-button"
            onClick={onCancelClick}
            sxSpinner={{ width: '2rem', height: '2rem' }}
            sx={{
              width: ['50%', 'auto'],
            }}
          >
            Cancel
          </ButtonWithLoadingState>
          <ButtonWithLoadingState
            variant="newPrimary"
            disabled={isDeleteButtonDisabled}
            data-testid={deleteTestId}
            ariaLabel="delete button"
            isLoading={isDeleteLoading}
            onClickOrPressEnter={onDeleteClick}
            sxSpinner={{ width: '2rem', height: '2rem' }}
            sx={{
              width: ['50%', 'auto'],
              minWidth: '8.4rem',
            }}
          >
            Delete
          </ButtonWithLoadingState>
        </Flex>,
        modalFooterRef.current,
      )
    : null
}
